import React from 'react';
import {
  InlineSelect,
  MultiSelect,
  DateBoxField,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {Form, Grid} from 'semantic-ui-react';
import _ from 'lodash';

const ThingsToDoFilter = ({filters, setFilters, filterOptions}) => {
  const updateFilterComboBox = (e) => {
    const filterName = e.name;
    const filterVal = e.value;
    setFilters({
      ...filters,
      [filterName]: filterVal,
    });
  };
  const updateFilter = (e) => {
    const filterName = e.target.name;
    const filterVal = e.target.value;
    setFilters({
      ...filters,
      [filterName]: filterVal,
    });
  };
  return (
    <Grid.Column key="gridFiltersColumn">
      <Form key="grantsFilterForm">
        <h5>Filter by:</h5>
        <MultiSelect
          key="fundingOpportunityNameTextBox"
          title="Funding Opportunity Name"
          name="fundingOpportunityName"
          label="Funding Opportunity name"
          id="fundingOpportunityNameString"
          labeled="true"
          search="true"
          selection
          value={filters.fundingOpportunityName || ''}
          options={filterOptions.fundingOpportunityNames || []}
          onChange={(e, data) => updateFilterComboBox(data)}
        />
        <MultiSelect
          key="recipientSelect"
          id="recipient"
          label="Recipient"
          labeled="true"
          search="true"
          selection
          title="Recipient"
          name="recipient"
          value={filters.recipient || ''}
          onChange={(e, data) => updateFilterComboBox(data)}
          options={filterOptions ? filterOptions.recipients : []}
        />
        {!_.isEmpty(filterOptions.subRecipients) && (
          <MultiSelect
            key="subrecipientSelect"
            id="subrecipient"
            label="Subrecipient"
            labeled="true"
            search="true"
            selection
            title="Subrecipient"
            name="subRecipient"
            value={filters.subRecipient || ''}
            onChange={(e, data) => updateFilterComboBox(data)}
            options={filterOptions.subRecipients}
          />
        )}
        <MultiSelect
          key="disasterTypeSelect"
          id="disasterType"
          label="Disaster type"
          labeled="true"
          search="true"
          selection
          title="Disaster type"
          name="disasterType"
          value={filters.disasterType || ''}
          onChange={(e, data) => updateFilterComboBox(data)}
          options={filterOptions ? filterOptions.disasterTypes : []}
        />
        {/* Due Date should not be a dropdown, should be a numeric text field */}
        <DateBoxField
          key="dueDateSelect"
          id="dueDate"
          label="Due date"
          labeled="true"
          title="Due date"
          name="dueDate"
          value={filters.dueDate || ''}
          handleChange={updateFilter}
        />
        <InlineSelect
          key="grantStatusSelect"
          id="grantStatus"
          label="Status"
          labeled="true"
          selection
          title="Filter by Grant Status"
          name="status"
          value={filters.status || ''}
          handleChange={updateFilter}
          options={filterOptions ? filterOptions.status : []}
        />
      </Form>
    </Grid.Column>
  );
};

export default ThingsToDoFilter;
